import { render, staticRenderFns } from "./LockedIcon.vue?vue&type=template&id=e52c3e8e"
import script from "./LockedIcon.vue?vue&type=script&lang=js"
export * from "./LockedIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports